<template>
  <div class="management-contract">
    <el-form ref="form" :model="filtersForm" label-width="80px" inline>
      <el-form-item label="处方单号">
        <el-input
          v-model="filtersForm.orderNo"
          placeholder="请输入处方单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="患者姓名">
        <el-input
          v-model="filtersForm.compatName"
          placeholder="请输入患者姓名"
        ></el-input>
      </el-form-item>
      <!--<el-form-item label="申请日期">-->
      <!--<el-date-picker-->
      <!--v-model="daterange"-->
      <!--type="daterange"-->
      <!--value-format="yyyy-MM-dd"-->
      <!--range-separator="-"-->
      <!--start-placeholder="开始日期"-->
      <!--end-placeholder="结束日期"-->
      <!--&gt;</el-date-picker>-->
      <!--</el-form-item>-->
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <el-radio-group v-model="checkedStatus">
      <el-radio-button
        v-for="state in states"
        :label="state.label"
        :key="state.text"
        >{{ state.text }}
      </el-radio-button>
    </el-radio-group>
    <el-table
      :data="list"
      v-loading="loading"
      border
      :cell-class-name="cellRedShow"
    >
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column prop="orderNo" label="处方单号"></el-table-column>
      <el-table-column
        prop="orderType"
        :formatter="formatterType"
        label="处方类型"
      ></el-table-column>
      <el-table-column prop="compatName" label="患者姓名"></el-table-column>
      <el-table-column prop="diagnosis" label="患者诊断"></el-table-column>
      <el-table-column
        v-if="checkedStatus === 'REBACK' || checkedStatus === ''"
        label="拒绝原因"
        prop="refuseReason"
      >
        <!--<template slot-scope="scope">-->
        <!--<span :title="scope.row.refuseReason" class="color_red">{{scope.row.refuseReason}}</span>-->
        <!--</template>-->
      </el-table-column>
      <el-table-column prop="docName" label="开方医生"></el-table-column>
      <el-table-column
        prop="createTime"
        :formatter="formatterCreateTime"
        label="开方时间"
        width="180"
      ></el-table-column>
      <el-table-column
        v-if="checkedStatus !== 'REBACK'"
        prop="status"
        :formatter="formatterStatus"
        label="状态"
      ></el-table-column>
      <el-table-column
        v-if="checkedStatus === 'REBACK'"
        prop="subStatus"
        :formatter="formatterSubStatus"
        label="状态"
      ></el-table-column>
      <el-table-column prop="returnCount" label="被退回记录"></el-table-column>
      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
          <!-- <el-button @click.prevent="showCheckDialog(scope.row.id)"
                               v-if="['CANCEL','PAY','SHIPPING','COMPLETE','COMMENT'].includes(scope.row.status)"
                               type="primary" size="small">查看详情
                    </el-button>
                    <el-button @click.prevent="seePDF(scope.row.recipePdfUrl)"
                               v-if="scope.row.recipePdfUrl"
                               type="primary" size="small">查看PDF
                    </el-button>
                    <el-button v-if="scope.row.status === 'REBACK'" @click.prevent="goToEPrescription(scope.row)"
                               type="primary" size="small">再次提交
                    </el-button>
                    <el-button v-if="['ISSUE','AUDIT'].includes(scope.row.status)" @click.prevent="reCall(scope.row.id)"
                               type="primary" size="small">召回处方
                    </el-button> -->
          
          <el-button
            @click="getDetails(scope.row.id)"
            size="small"
            type="primary"
            >详情
          </el-button>
          <el-button
            v-if="scope.row.openSignature == false"
            @click="deleteList(scope.row.id)"
            type="danger"
            size="small"
            >删除
          </el-button>
          <el-button
            v-if="
              scope.row.openSignature == false &&
              scope.row.subStatus != 'REFUSE'
            "
            @click.prevent="autograph(scope.row.id)"
            type="success"
            size="small"
            >签名
          </el-button>
          <el-button
            @click.prevent="seePDF(scope.row.recipePdfUrl)"
            v-if="scope.row.recipePdfUrl"
            type="primary"
            size="small"
            >电子处方
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="pagination-wrapper" type="flex" justify="end">
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="page.pageNum"
        :total="page.total"
        @current-change="onCurrentChange"
      ></el-pagination>
    </el-row>
    <check-dialog ref="checkDialog" :info="orderInfo"></check-dialog>
  </div>
</template>

<script>
import { MessageBox, Message } from "element-ui";
import { tokenCache } from "../../../cache/tokenCache";
import { timeFormat, sex } from "ty-vue-filters";
import CheckDialog from "../prescription/check-dialog";

const PAGE = {
  pageNum: 1,
  pageSize: 10,
  pages: 1,
  total: 0,
};
export default {
  data() {
    return {
      daterange: [],
      filtersForm: {
        orderNo: "",
        patName: "",
        // startDate: "",
        // endDate: ""
      },
      list: [],
      states: [
        {
          label: "",
          text: "全部",
        },
        {
          label: "REBACK",
          text: "待发布",
        },
        {
          label: "ISSUE",
          text: "待审核",
        },
        {
          label: "AUDIT",
          text: "已审核",
        },
        {
          label: "CANCEL",
          text: "已作废",
        },
      ],
      loading: false,
      page: PAGE,
      checkedStatus: "",
      orderInfo: {},
    };
  },
  components: { CheckDialog },
  watch: {
    daterange(val) {
      this.filtersForm.startDate = val ? val[0] : "";
      this.filtersForm.endDate = val ? val[1] : "";
    },
    checkedStatus: {
      handler() {
        this.pages = PAGE;
        this.getList();
      },
      immediate: true,
    },
  },
  methods: {
    getDetails(id) {
      this.$router.push({
        path: "/main/PrescriptionDetailed",
        query: { id: id },
      });
    },
    deleteList(id) {
      this.$confirm("确定删除此处方吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let options = {
            token: localStorage.getItem("token"),
            orderId: id,
          };
          let res = await this.$http(
            "smarthos.recipe.order.delete.V1",
            options
          );
          if (res.code == 0) {
            Message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
            this.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async confirm(value, id) {
      if (value.value == null) {
        Message({
          showClose: true,
          message: "请输入短信验证码",
          type: "error",
        });
        return;
      }
      let that = this;
      let options = {
        token: localStorage.getItem("token"),
        orderId: id,
        businessType: "OPEN_RECIPE",
        verificationCode: value.value,
        docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
      };
      let res = await this.$http(
        "smarthos.recipe.order.sign.send.code.check",
        options
      );
      if (res.code == 0) {
        that.signature(id);
      }
    },
    async signature(id) {
      let that = this;
      let options = {
        token: localStorage.getItem("token"),
        orderId: id,
      };
      let res = await this.$http(
        "smarthos.recipe.order.open.doc.sign",
        options
      );
      if (res.code == 0) {
        Message({
          showClose: true,
          message: "签名成功",
          type: "success",
        });
        that.getList();
      }
    },
    async VerificationCode(id) {
      let that = this;
      let options = {
        token: localStorage.getItem("token"),
        orderId: id,
        businessType: "OPEN_RECIPE",
        docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
      };
      let res = await this.$http(
        "smarthos.recipe.order.sign.send.code",
        options
      );
      if (res.code == 0) {
        MessageBox.prompt("请输入短信验证码", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(async (inputValue) => {
            that.confirm(inputValue, id);
          })
          .catch(() => {
            return;
          });
      }
    },
    shortMessage(id) {
      let that = this;
      that
        .$confirm("即将给您本人手机号发送短信验证是否本人", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          that.VerificationCode(id);
        })
        .catch(() => {});
    },
    async determine(id) {
      let that = this;
      this.$confirm("签名之后处方不可编辑删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let options = {
            token: localStorage.getItem("token"),
            orderId: id,
          };
          let res = await this.$http(
            "smarthos.recipe.order.open.doc.sign",
            options
          );
          if (res.code == 0) {
            Message({
              showClose: true,
              message: "签名成功",
              type: "success",
            });
            that.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消签名",
          });
        });
    },
    async autograph(id) {
      let that = this;
      let options = {
        token: localStorage.getItem("token"),
        key: "RECIPE_SEND_MEG_CODE_SWITCH",
      };
      let res = await this.$http("smarthos.system.param.key", options);
      if (res.code == 0) {
        if (res.obj.paramValue == "0") {
          that.determine(id);
        } else if (res.obj.paramValue == "1") {
          that.shortMessage(id);
        }
      }
    },
    seePDF(url) {
      window.open(url);
    },
    cellRedShow(row, column, rowIndex, columnIndex) {
      if (row.column.label == "拒绝原因") {
        return "color_red";
      }
    },
    goToEPrescription(row) {
      this.$router.push({
        path: "/main/e-prescription",
        query: { rpId: row.id, compatId: row.compatId, bizId: row.bizId },
      });
    },
    async reCall(id) {
      MessageBox.confirm("确认召回处方?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let options = {
            token: localStorage.getItem("token"),
            orderId: id,
          };
          let res = await this.$http("smarthos.recipe.order.recall", options);
          if (res.code == 0) {
            Message({
              showClose: true,
              message: "操作成功",
              type: "success",
            });
            location.reload();
          }
        })
        .catch(() => {});
    },
    onSubmit() {
      this.getList();
    },
    async showCheckDialog(id) {
      const { code, obj, msg } = await this.$http(
        "smarthos.recipe.order.info",
        { orderId: id }
      );
      if (code == 0) {
        this.orderInfo = obj;
        this.$refs.checkDialog.show();
      } else {
        this.$message.error(msg);
      }
    },

    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const options = {
        status: this.checkedStatus,
        token: tokenCache.get(),
        ...this.page,
        ...this.filtersForm,
      };
      const { code, list, page, msg } = await this.$http(
        "smarthos.recipe.order.opendoc.list.page",
        options
      );
      if (code === "0") {
        this.loading = false;
        this.list = list;
        this.page = page;
      } else {
        this.$message.error(msg);
      }
    },
    formatterCreateTime(row, column, createTime) {
      return timeFormat(createTime, "%Y/%m/%d %H:%M");
    },
    formatterType(row, column, code) {
      const orderType = {
        WESTERN_RECIPE: "西药方",
        CHINESE_RECIPE: "草药方",
        PRESCRIPT_RECIPE: "成药方",
      };
      return orderType[code];
    },
    formatterStatus(row, column, code) {
      const statusObj = {
        REBACK: "待发布",
        ISSUE: "待审核",
        AUDIT: "已审核",
        PAY: "已审核",
        SHIPPING: "已审核",
        COMPLETE: "已审核",
        COMMENT: "已审核",
        CANCEL: "已作废",
      };
      return statusObj[code];
    },
    formatterSubStatus(row, column, code) {
      const statusObj = {
        REFUSE: "已拒绝",
        RECALL: "已召回",
      };
      return statusObj[code];
    },
    formatterSex(row, column, code) {
      return sex(code, 2);
    },
  },
};
</script>

<style lang="scss">
.management-contract {
  .el-form {
    padding-top: 22px;
    border-top: 1px solid #f5f5f5;
  }
  .el-table {
    margin-top: 15px;
  }
  .pagination-wrapper {
    padding: 20px 0;
  }
  .el-table .cell {
    max-height: 69px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
</style>
